<template>
    <div class="filt-containt">
        <div class="select-box" :class="{ 'activeted': isCheck }">
            <div class="single-box">
                <div class="title">{{ title }}：</div>
                <ul class="select-list">
                    <li
                        class="select-item"
                        @click="handleSelectAll"
                        :class="{ 'activeted': selectAll }"
                    >
                        <!-- <span>不限</span> -->
                        <span>{{KDApi.getLangMsg(this.model, "filt.unlimited")}}</span>
                    </li>
                    <li
                        v-for="(item,index) in selectItemList"
                        :key="'si' + index"
                        class="select-item"
                        :class="{ 'activeted': (!selectAll && selectMap.get(item) && hascode) }"
                        @click="handleSelect(item)"
                    >
                        <span>{{ item.name }}</span>
                    </li>
                </ul>
            </div>
            <div class="btn-box" v-show="isCheck">
                <div class="i-btn i-btn-cancel" @click="cancelCheck">{{KDApi.getLangMsg(this.model, "btn.cancel")}}</div>
                <div @click="sureCheck" class="i-btn i-btn-sure">{{KDApi.getLangMsg(this.model, "btn.confirm")}}</div>
            </div>
        </div>
        <div class="op-icon" v-show="!isCheck" @click="changeSelectFun">
            <span>{{KDApi.getLangMsg(this.model, "btn.multichoose")}}</span>
        </div>
    </div>
</template>

<script>
// const ALL_VAL = { name: "不限", val: "all" }

export default {
    inject: ["model", "KDApi"],
    props: {
        selectItemList: Array,
        title: String,
    },
    data() {
        return {
            isCheck: false,
            selectMap: new WeakMap(),
            selectAll: true,
            selectedList: [{ name: KDApi.getLangMsg(this.model, "filt.unlimited"), val: "all" }],
            hascode: 1
        }
    },
    created() {
        this.selectItemList.map(item => {
            this.selectMap.set(item, false)
        })
    },
    methods: {
        handleSelect(selectedItem) {
            this.hascode = parseInt(Math.random() * 999999999 + 2)
            this.selectAll = false
            if (this.isCheck) {
                this.selectMap.set(selectedItem, !this.selectMap.get(selectedItem))
            } else {
                this.selectItemList.map(item => {
                    this.selectMap.set(item, false)
                })
                this.selectMap.set(selectedItem, true)
                this.selectedList = [selectedItem]
                this.$emit("handleSelected", this.selectedList)
            }

        },
        handleSelectAll() {
            this.selectAll = true
            this.selectItemList.map(item => {
                this.selectMap.set(item, false)
            })
            if (this.isCheck) {

            } else {
                this.selectedList = [{ name: KDApi.getLangMsg(this.model, "filt.unlimited"), val: "all" }]
                this.$emit("handleSelected", this.selectedList)
            }
        },
        sureCheck() {
            this.isCheck = false
            if (this.selectAll) {
                this.selectItemList.map(item => {
                    this.selectMap.set(item, false)
                })
                this.selectedList = [{ name: KDApi.getLangMsg(this.model, "filt.unlimited"), val: "all" }]
            } else {
                this.selectedList = []
                this.selectItemList.map(item => {
                    if (this.selectMap.get(item)) {
                        this.selectedList.push(item)
                    }
                })
            }
            this.$emit("handleSelected", this.selectedList)
        },
        cancelCheck() {
            this.isCheck = false
            this.selectItemList.map(item => {
                this.selectMap.set(item, false)
            })
            if (this.selectAll) {

            } else {
                if (this.selectedList[0].val === "all") {
                    this.selectAll = true
                } else {
                    this.selectMap.set(this.selectedList[0], true)
                }
            }
        },
        changeSelectFun() {
            this.isCheck = true
            if (this.selectAll) {

            } else {

            }
        }
    }
}
</script>

<style lang="less" scoped>
.filt-containt {
    width: 100%;
    align-items: center;
    border-top: 1px solid var(--weak-border-color);
    display: flex;
    justify-content: space-between;
    .select-box {
        flex: 1;
        .single-box {
            display: flex;
            align-items: center;
            flex: 1;
            .title {
                color: var(--third-text-color);
                font-size: 12px;
            }
            .select-list {
                flex-grow: 1;
                overflow: hidden;
                position: relative;
                list-style: none;
                display: flex;
                .select-item {
                    display: flex;
                    margin: 0 15px;
                    align-items: center;
                    border: 1px solid transparent;
                    border-radius: 2px;
                    max-width: 266px;
                    cursor: pointer;
                    color: var(--secondary-text-color);
                    &.activeted {
                        color: #5e80eb;
                        border: 1px solid #5e80eb;
                        background-color: #fff;
                        border-radius: 2px;
                        max-width: 266px;
                        margin: 8px 12px;
                        padding: 3px 12px;
                    }
                }
            }
        }
        .btn-box {
            width: 100%;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            .i-btn {
                &.i-btn-cancel {
                    height: 28px;
                    width: 60px;
                    overflow: hidden;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border: 1px solid #a7b5d3;
                    border-radius: 2px;
                    font-size: 12px;
                    letter-spacing: 0;
                    cursor: pointer;
                    margin-bottom: 11px;
                    margin-right: 12px;
                    &:hover {
                        color: var(--theme-color);
                        border-color: var(--theme-color);
                    }
                }
                &.i-btn-sure {
                    height: 28px;
                    width: 60px;
                    overflow: hidden;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border: 1px solid #a7b5d3;
                    border-radius: 2px;
                    font-size: 12px;
                    letter-spacing: 0;
                    cursor: pointer;
                    margin-bottom: 11px;
                    background: var(--theme-color);
                    color: #fff;
                    &:hover {
                        background: var(--theme-color-level5);
                    }
                }
            }
        }
        &.activeted {
            background: #fff;
        }
    }
    .op-icon {
        display: flex;
        justify-content: center;
        min-width: 60px;
        height: 24px;
        padding: 0 5px;
        background: #fff;
        border: 1px solid #e2e2e2;
        border-radius: 2px;
        font-size: 12px;
        color: #5b6373;
        letter-spacing: 0;
        align-items: center;
        cursor: pointer;
    }
}
</style>